import { urlForImage } from 'lib/sanity.image'
import { formattedPuslishDate } from 'lib/helpers'

import Image from 'next/image'

export const WorldHeader = ({
  avatar,
  author,
  published,
  category,
}: {
  avatar?: any
  author?: any
  published?: any
  category?: any
}) => {
  return (
    <div className="flex items-center gap-10 pb-14 text-10">
      {avatar ? (
        <div className="relative h-28 w-28 rounded-full border-1.5 border-yellow">
          <Image
            src={urlForImage(avatar).auto('format').url()}
            alt={`Avatar for ${author}`}
            fill
            style={{ objectFit: 'cover' }}
          />
        </div>
      ) : null}
      {category ? <div className="text-darkerGray">{category.slug}</div> : null}
      {author ? (
        <div className="font-medium text-darkGray">@{author}</div>
      ) : null}
      {published ? (
        <div className="text-gray">{formattedPuslishDate(published)}</div>
      ) : null}
    </div>
  )
}
